module.exports = __webpack_public_path__ + "img/syllabus-level3-line.5980c202.png";